import * as MuiLink from '@mui/material/Link'
import React from 'react'
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom'

export type LinkProps = MuiLink.LinkProps

export const LinkBehavior = React.forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>((props, ref) => {
  const { href, ...other } = props
  // Map href (Material UI) -> to (react-router)
  return <RouterLink ref={ref} to={href} {...other} />
})

export function Link({ children, ...props }: LinkProps) {
  if (props.color === 'secondary') {
    props.className += ' secondaryColor'
  }
  return (
    <MuiLink.default underline='hover' {...props}>
      {children}
    </MuiLink.default>
  )
}
